module.exports = __webpack_public_path__ + "static/media/mira_beauty_search.10996131.gif";